import { Drawer as AntDrawer } from "antd";

const Drawer = ({ open, onClose, title, content,maskClosable,forceRender }) => {
  return (
    <>
      <AntDrawer
        size="large"
        title={title}
        placement="right"
        onClose={onClose}
        open={open}
        maskClosable={maskClosable}
        forceRender={forceRender}
      >
        {content}
      </AntDrawer>
    </>
  );
};
export default Drawer;
